import React from 'react';
import { Board, Legend } from './Board';
import { hasBranches, hasLinks } from '../game/model.mjs';

// A read-only illustration, separate from match state and recorded research data.
const fixedShips = [
  { id: 'example-s2', name: 'S2', cells: ['C1', 'C2', 'C3'] },
  { id: 'example-s3', name: 'S3', cells: ['E1', 'E2', 'E3', 'E4'] },
];
const marks = {
  C1: { result: 'hit' }, C2: { result: 'hit' },
  C3: { result: 'sunk' }, D4: { result: 'miss' },
};
const captions = {
  L0: 'Solid outlines show fixed ships. Two hits and a sinking shot have sunk S2; the circle marks a miss.',
  L1: 'The circle on S1 shows a shot resisted by its defense. In this level, a miss does not always mean empty water.',
  L2: 'The dashed outlines show two possible positions of S1. In this example, S2 has already resolved and sunk.',
  L3: 'S1 has two possible positions. The L on S3 marks a link to a square on the opposing board.',
};

export function OpeningBoard({ level }) {
  const branches = hasBranches(level);
  const positions = [
    ...fixedShips,
    { id: 'example-s1-a', name: 'S1', cells: ['A1', 'A2'], possible: branches, probability: branches ? .5 : 1 },
    ...(branches ? [{ id: 'example-s1-b', name: 'S1', cells: ['B1', 'B2'], possible: true, probability: .5 }] : []),
  ];
  const exampleMarks = level === 'L1' ? { ...marks, A1: { result: 'miss' } } : marks;
  return <figure className="opening-board" aria-labelledby="example-board-title">
    <Board label="Example" positions={positions} marks={exampleMarks} links={hasLinks(level) ? ['E3'] : []} />
    <div className="example-board-label" id="example-board-title">Example board</div>
    <Legend links={hasLinks(level)} />
    <figcaption>
      <p className="opening-caption" aria-live="polite">{captions[level]}</p>
      <p className="small muted">Illustration only; your fleet is placed next.</p>
    </figcaption>
  </figure>;
}
